<template>
    <main>

        <!-- Tarjetas de Resumen Métrico -->
        <div class="row mt-3">
            <!-- Suministrados -->
            <div class="col-xl-4 col-md-6">
                <div class="card border-left-primary border-left-lg shadow h-100 py-2">
                    <div class="card-body">
                        <div class="row no-gutters align-items-center">
                            <div class="col mr-2">
                                <div class="text-xs font-weight-bold text-primary text-uppercase mb-1">
                                    Total Suministrados</div>
                                <div class="h5 mb-0 font-weight-bold text-gray-800">{{ totales.total_suministrados_cc }}
                                    <small class="text-muted">cc</small>
                                </div>
                            </div>
                            <div class="col-auto">
                                <i class="fas fa-tint fa-2x text-gray-300"></i>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <!-- Eliminados -->
            <div class="col-xl-4 col-md-6">
                <div class="card border-left-success border-left-lg shadow h-100 py-2">
                    <div class="card-body">
                        <div class="row no-gutters align-items-center">
                            <div class="col mr-2">
                                <div class="text-xs font-weight-bold text-success text-uppercase mb-1">
                                    Total Eliminados</div>
                                <div class="h5 mb-0 font-weight-bold text-gray-800">{{ totales.total_eliminados_cc }}
                                    <small class="text-muted">cc</small>
                                </div>
                            </div>
                            <div class="col-auto">
                                <i class="fas fa-external-link-alt fa-2x text-gray-300"></i>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <!-- Balance Hídrico -->
            <div class="col-xl-4 col-md-6">
                <div
                    :class="['card shadow h-100 py-2', totales.balance_hidrico_cc >= 0 ? 'border-left-info border-left-lg' : 'border-left-danger border-left-lg']">
                    <div class="card-body">
                        <div class="row no-gutters align-items-center">
                            <div class="col mr-2">
                                <div
                                    :class="['text-xs font-weight-bold text-uppercase mb-1', totales.balance_hidrico_cc >= 0 ? 'text-info' : 'text-danger']">
                                    Balance Hídrico</div>
                                <div class="h5 mb-0 font-weight-bold text-gray-800">
                                    {{ totales.balance_hidrico_cc >= 0 ? '+' : '' }}{{ totales.balance_hidrico_cc }}
                                    <small class="text-muted">cc</small>
                                </div>
                            </div>
                            <div class="col-auto">
                                <i class="fas fa-balance-scale fa-2x text-gray-300"></i>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- Tabla -->
        <div class="card mt-3 p-1">

            <div v-if="cargandoTipos" class="cargando">Cargando tipos...</div>

            <div v-else class="tabla-scroll">
                <div class="row mt-2" v-if="fecha_creacion">
                    <div class="col-md-12">
                        <div class="form-group p-2">
                            <label for="fecha" class="font-weight-bold">Fecha de registro</label>
                            <span
                                class="ml-2 badge badge-primary-soft badge-marketing text-dark font-weight-bold text-sm">{{
                                fecha_creacion | formatDateTimeFilter }}</span>
                        </div>
                    </div>
                </div>

                <!-- <div class="row">
                    <div class="col-md-12">
                        <div class="form-group">
                            <label for="fecha">Fecha</label>
                            <input type="date" class="form-control mb-2" v-model="fecha">
                        </div>
                    </div>
                </div> -->
                <table>
                    <thead>
                        <tr>
                            <th rowspan="2" class="th-base" style="width: 130px;">Fecha</th>
                            <th rowspan="2" class="th-base" style="width: 110px;">Hora</th>
                            <th rowspan="2" class="th-base">Descripción</th>
                            <th :colspan="tiposSuministrados.length" class="th-grupo th-sum">SUMINISTRADOS (CC)</th>
                            <th :colspan="tiposEliminados.length" class="th-grupo th-eli">ELIMINADOS (CC)</th>
                            <th rowspan="2" class="th-accion"></th>
                        </tr>
                        <tr>
                            <th v-for="tipo in tiposSuministrados" :key="tipo.id" class="th-sub th-sum-sub"
                                style="width: 65px; min-width: 65px;">
                                {{ tipo.nombre }}
                            </th>
                            <th v-for="tipo in tiposEliminados" :key="tipo.id" class="th-sub th-eli-sub"
                                style="width: 65px; min-width: 65px;">
                                {{ tipo.nombre }}
                            </th>
                        </tr>
                    </thead>

                    <tbody>
                        <tr v-for="(fila, index) in filas" :key="fila.id_fila">
                            <td style="padding: 2px;">
                                <input v-model="fila.fecha" type="date" :readonly="!!fila.id_detalle"
                                    class="form-control form-control-sm" @change="recalcular" />
                            </td>
                            <td style="padding: 2px;">
                                <input v-model="fila.hora" type="time" :readonly="!!fila.id_detalle"
                                    class="form-control form-control-sm" @change="recalcular" />
                            </td>
                            <td style="padding: 2px;">
                                <input v-model="fila.descripcion" type="text" :readonly="!!fila.id_detalle"
                                    class="form-control form-control-sm" placeholder="" />
                            </td>
                            <!-- Suministrados -->
                            <td v-for="tipo in tiposSuministrados" :key="tipo.id" style="padding: 2px; width: 65px;">
                                <input v-model.number="fila.valores[tipo.id]" :readonly="!!fila.id_detalle"
                                    type="number" min="0" class="form-control form-control-sm" @input="recalcular" />
                            </td>
                            <!-- Eliminados -->
                            <td v-for="tipo in tiposEliminados" :key="tipo.id" style="padding: 2px; width: 65px;">
                                <input v-model.number="fila.valores[tipo.id]" :readonly="!!fila.id_detalle"
                                    type="number" min="0" class="form-control form-control-sm" @input="recalcular" />
                            </td>
                            <td class="d-flex">
                                <button class="btn btn-icon btn-xs btn-transparent" type="button" v-if="!fila.id_detalle"
                                    @click="eliminarFila(index)">
                                    <i class="fas fa-times"></i>
                                </button>
                                <button class="btn btn-icon btn-xs btn-transparent" type="button"
                                    @click="mostrarInfoUsuario(fila.user)" v-if="fila.user">
                                    <i class="fas fa-user text-primary"></i>
                                </button>
                                <button class="btn btn-icon btn-xs text-danger btn-transparent"
                                    @click="eliminarDetalle(fila.id_detalle)" v-if="fila.id_detalle && fila.can_delete">
                                    <i class="fas fa-trash-alt"></i>
                                </button>

                            </td>
                        </tr>
                    </tbody>

                    <tfoot>
                        <tr>
                            <td colspan="3" class="tf-lbl">TOTAL</td>
                            <td v-for="tipo in tiposSuministrados" :key="tipo.id" class="tf-sum">{{
                                totalesPorTipo[tipo.id] || 0 }}</td>
                            <td v-for="tipo in tiposEliminados" :key="tipo.id" class="tf-eli">{{
                                totalesPorTipo[tipo.id] || 0 }}</td>
                            <td></td>
                        </tr>
                    </tfoot>
                </table>
            </div>
        </div>
        <div class="d-flex justify-content-end mt-2">
            <button class="btn btn-dark btn-sm" @click="generarPDF"><i class="fas fa-file-pdf text-danger fa-fw"></i>
                Generar pdf</button>
            <button class="btn btn-primary btn-sm ml-2" @click="agregarFila()"><i class="fas fa-plus"></i> Agregar
                fila</button>
            <button class="btn btn-success btn-sm ml-2" :disabled="guardando" @click="guardar">
                <span v-if="guardando">Guardando...</span>
                <span v-else> <i class="fas fa-save"></i> Guardar</span>
            </button>
        </div>

    </main>
</template>

<script>
import formatosUrgenciaService from '@/services/formatosUrgenciaService.js';
import Toast from '../../../components/common/utilities/toast';
import dayjs from 'dayjs';
import Swal from 'sweetalert2';

export default {
    name: 'ControlLiquidos',

    props: {
        idHistoria: {
            type: [Number, String],
            required: true
        }
    },

    data() {
        return {
            uid: 1,
            idControl: null,
            cargandoTipos: true,
            tipos: [],          // viene de GET /api/liquido-tipo
            filas: [],          // filas de la tabla
            fecha: dayjs().format('YYYY-MM-DD'),
            totalesPorTipo: {}, // { id_tipo: suma }
            totales: {
                total_suministrados_cc: 0,
                total_eliminados_cc: 0,
                balance_hidrico_cc: 0
            },
            guardando: false,
            fecha_creacion: null
        }
    },

    computed: {
        tiposSuministrados() {
            return this.tipos.filter(t => t.tipo === 'suministrado').sort((a, b) => a.orden - b.orden)
        },
        tiposEliminados() {
            return this.tipos.filter(t => t.tipo === 'eliminado').sort((a, b) => a.orden - b.orden)
        }
    },

    async created() {
        await this.cargarTipos()
        await this.cargarDetalle()
        // Datos de ejemplo de la imagen
        this.agregarFila()
    },

    methods: {
        mostrarInfoUsuario(user) {
            Swal.fire({
                title: '<span class="h6 font-weight-bold">Información de Registro</span>',
                html: `<div class="small text-muted">Este registro fue realizado por:</div>
                       <div class="font-weight-bold mt-2">${user.name}</div>`,
                icon: 'info',
                confirmButtonText: 'Entendido',
                confirmButtonColor: '#185FA5',
                customClass: {
                    confirmButton: 'btn btn-sm btn-primary'
                }
            });
        },
        async cargarTipos() {
            try {
                const { data } = await formatosUrgenciaService.showTiposLiquido()
                this.tipos = data.data
            } catch (e) {
                console.error('Error cargando tipos de líquido', e)
            } finally {
                this.cargandoTipos = false
            }
        },

        // ── Crea una fila vacía con un objeto valores{ id_tipo: cantidad } ─────
        nuevaFila(datos = {}) {
            // Inicializa todos los tipos en null
            const valores = {}
            this.tipos.forEach(t => { valores[t.id] = null })
            if (datos.valores) Object.assign(valores, datos.valores)

            return {
                uid: this.uid++,
                id_fila: datos.id_fila || crypto.randomUUID(),  // UUID nativo, sin librerías
                id_detalle: datos.id_detalle || null,
                hora: datos.hora || '',
                fecha: datos.fecha || '',
                descripcion: datos.descripcion || '',
                valores
            }
        },

        agregarFila() {
            /* const duplicada = this.filas.some(
                f => f.hora === datos.hora && f.descripcion === datos.descripcion
            )
            if (duplicada) {
                Toast.fire({ icon: 'error', title: 'Ya existe una fila con esa hora y observación' });
                return
            } */
            let datos = { fecha: dayjs().format('YYYY-MM-DD'), hora: '', descripcion: '' }
            this.filas.push(this.nuevaFila(datos))
            this.$nextTick(this.recalcular)
        },

        eliminarFila(idx) {
            this.filas.splice(idx, 1)
            this.recalcular()
        },

        recalcular() {
            const n = v => Number(v) || 0

            // Total por tipo
            const porTipo = {}
            this.tipos.forEach(t => {
                porTipo[t.id] = this.filas.reduce((acc, f) => acc + n(f.valores[t.id]), 0)
            })
            this.totalesPorTipo = porTipo

            // Totales por grupo
            const ts = this.tiposSuministrados.reduce((acc, t) => acc + (porTipo[t.id] || 0), 0)
            const te = this.tiposEliminados.reduce((acc, t) => acc + (porTipo[t.id] || 0), 0)

            this.totales.total_suministrados_cc = ts
            this.totales.total_eliminados_cc = te
            this.totales.balance_hidrico_cc = ts - te
        },

        // ── Genera el payload para POST /api/control-liquidos ─────────────────
        // Estructura que espera la BD:
        getPayload() {
            const filasNuevas = this.filas.filter(f => f.id_detalle === null)

            return {
                id_historia: this.idHistoria,
                fecha: dayjs().format('YYYY-MM-DD'),
                total_suministrados_cc: this.totales.total_suministrados_cc,
                total_eliminados_cc: this.totales.total_eliminados_cc,
                balance_hidrico_cc: this.totales.balance_hidrico_cc,
                detalle: filasNuevas.flatMap(fila =>
                    this.tipos
                        .filter(tipo => Number(fila.valores[tipo.id]) > 0)
                        .map(tipo => ({
                            id_tipo: tipo.id,
                            id_fila: fila.id_fila,
                            hora: fila.hora,
                            fecha: fila.fecha,
                            cantidad_cc: Number(fila.valores[tipo.id]),
                            descripcion: fila.descripcion || null,

                        }))
                )

            }
        },
        async cargarDetalle() {
            if (!this.idHistoria) return
            try {
                const { data } = await formatosUrgenciaService.showControlLiquidosByHistoria(this.idHistoria);

                if (!data.status || !data.data) return

                this.idControl = data.data.id_control_liquido
                this.fecha_creacion = data.data.created_at

                const grupos = {}
                data.data.detalle.forEach(item => {
                    if (!grupos[item.id_fila]) {
                        grupos[item.id_fila] = {
                            uid: this.uid++,
                            can_delete: item.can_delete,
                            user: item.user,
                            id_fila: item.id_fila,
                            id_detalle: item.id,      // bloquea los inputs
                            hora: item.hora,
                            fecha: item.fecha,
                            descripcion: item.descripcion || '',
                            valores: {}
                        }
                        this.tipos.forEach(t => { grupos[item.id_fila].valores[t.id] = null })
                    }
                    grupos[item.id_fila].valores[item.id_tipo_liquido] = item.cantidad_cc
                })

                this.filas = Object.values(grupos)
                this.recalcular()

            } catch (e) {
                console.error('Error cargando detalle', e)
            }
        },
        async guardar() {
            try {
                const filasNuevas = this.filas.filter(f => f.id_detalle === null)

                // Sin filas nuevas
                if (!filasNuevas.length) {
                    Toast.fire({ icon: 'info', title: 'No hay filas nuevas para guardar' });
                    return
                }

                // Valida que cada fila nueva tenga hora y al menos un valor
                const filasVacias = filasNuevas.filter(fila => {
                    const tieneHora = !!fila.hora
                    const tieneFecha = !!fila.fecha
                    const tieneObs = !!fila.descripcion
                    const tieneValor = this.tipos.some(t => Number(fila.valores[t.id]) > 0)
                    return !tieneHora || !tieneFecha || !tieneObs || !tieneValor
                })

                if (filasVacias.length) {
                    Swal.fire({
                        icon: 'warning',
                        text: 'Hay ' + filasVacias.length + ' fila(s) sin hora, sin fecha, sin descripción o sin ningún valor en cc'
                    });
                    return
                }
                this.guardando = true;
                this.LoaderSpinnerShow();
                const payload = this.getPayload()
                await formatosUrgenciaService.storeControlLiquidos(payload)
                this.LoaderSpinnerHide();
                Toast.fire({
                    icon: 'success',
                    title: 'Control de líquidos guardado exitosamente'
                });
                this.guardando = false;
                await this.cargarDetalle();
                this.agregarFila();
            } catch (error) {
                this.guardando = false;
                this.LoaderSpinnerHide();
                console.log(error)
                Toast.fire({
                    icon: 'error',
                    title: 'Error al guardar el control de líquidos'
                });
            }
        },
        async eliminarDetalle(id) {
            try {
                Swal.fire({
                    title: '¿Está seguro de eliminar el control?',
                    icon: 'question',
                    showCancelButton: true,
                    confirmButtonText: 'Sí, eliminar',
                    cancelButtonText: 'Cancelar',
                }).then(async (result) => {
                    if (result.isConfirmed) {
                        try {
                            this.LoaderSpinnerShow();
                            await formatosUrgenciaService.destroyControlLiquidos(id)
                            this.LoaderSpinnerHide();
                            await this.cargarDetalle();
                            this.agregarFila();
                            Toast.fire({
                                icon: 'success',
                                title: 'Control de líquidos eliminado exitosamente'
                            });
                        } catch (error) {
                            this.LoaderSpinnerHide();
                            console.log(error)
                            Toast.fire({
                                icon: 'error',
                                title: 'Error al eliminar el control de líquidos'
                            });
                        }
                    }
                });
            } catch (error) {
                this.LoaderSpinnerHide();
                console.log(error)
                Toast.fire({
                    icon: 'error',
                    title: 'Error al eliminar el control de líquidos'
                });
            }
        },
        generarPDF() {

            try {
                this.LoaderSpinnerShow();
                window.open(formatosUrgenciaService.generarPdfControlLiquidos(this.idControl));
                this.LoaderSpinnerHide();
            } catch (error) {
                this.LoaderSpinnerHide();
                console.log(error)
                Toast.fire({
                    icon: 'error',
                    title: 'Error al generar el control de líquidos'
                });
            }
        }
    }
}
</script>


<style scoped>
.control-liquidos {
    font-family: 'Segoe UI', Arial, sans-serif;
    font-size: 13px;
    color: #1a1a1a;
    padding: 1.5rem;
    background: #f0f0eb;
    min-height: 100vh;
}

.cargando {
    padding: 2rem;
    text-align: center;
    color: #888;
}


/* ── Tabla ── */
.tabla-card {
    background: #f5f5f0;
    border-radius: 10px;
    padding: 1rem 1.25rem;
}

.tabla-scroll {
    overflow-x: auto;
    margin-bottom: 10px;
}

table {
    width: 100%;
    border-collapse: separate;
    border-spacing: 0;
    min-width: 700px;
    table-layout: fixed;
}

thead th {
    padding: 8px 6px;
    text-align: center;
    font-size: 12px;
    font-weight: 600;
}

.th-base {
    color: #444;
    font-weight: 500;
    vertical-align: middle;
}

.th-grupo {
    border-radius: 6px 6px 0 0;
    padding: 6px 10px;
    font-size: 11px;
    letter-spacing: .4px;
}

.th-sum {
    background: #dde9f5;
    color: #185FA5;
}

.th-eli {
    background: #deecd5;
    color: #3B6D11;
}

.th-sub {
    font-weight: 500;
    font-size: 12px;
}

.th-sum-sub {
    color: #185FA5;
    background: #edf4fc;
}

.th-eli-sub {
    color: #3B6D11;
    background: #eaf3e0;
}

.th-accion {
    width: 32px;
}

tbody td {
    padding: 5px 4px;
    text-align: center;
}

tfoot td {
    padding: 8px 6px;
    font-weight: 700;
    font-size: 13px;
    border-top: 1.5px solid #ccc;
    text-align: center;
    background: #ebebE6;
}

.tf-lbl {
    text-align: left;
    padding-left: 10px;
    color: #666;
    font-weight: 600;
}

.tf-sum {
    color: #185FA5;
}

.tf-eli {
    color: #3B6D11;
}

.btn-del {
    background: none;
    border: none;
    cursor: pointer;
    font-size: 18px;
    color: #bbb;
    line-height: 1;
    padding: 2px 6px;
    border-radius: 5px;
}

.btn-del:hover {
    color: #A32D2D;
    background: #fce8e8;
}
</style>